export default {"src":"/_next/static/media/carbon_credit_illustration.36a892c8.svg","height":244,"width":300};